import React from 'react';
import { Box, Skeleton } from 'native-base';
import { useGeneralStyles } from '../../../shared/styles';
import { GIFTCARD_FLOWS, observer, useSpringBigStore } from '@springbig/shared';
import { Caption } from '~/shared/Typography';
import Button from '~/shared/Button';

const Point = () => {

    const { member, merchant } = useSpringBigStore();
    const gStyle = useGeneralStyles();

    const onConvertPointsToCash = () => {

        observer.emit('open-actionsheet', GIFTCARD_FLOWS.convertPointsToCash);
    };

    return (
        <Box alignItems={'center'} display={'flex'} justifyContent='center' flex={1} px={4} textAlign={'center'} >
            {(member.id || member?.balance) ? <Caption fontSize={36} fontWeight={200}>{member?.balance || '0'}</Caption> : <Skeleton h={'2.5rem'} w={'8rem'} rounded={'lg'} mb={'1rem'}/> }
            <Caption fontSize={22} fontWeight={100} text='giftCard.balance.point_balance' />
            {merchant?.points_cash_conversion_enabled && parseFloat(merchant.dollars_per_point) > 0 && <Button
                borderColor={gStyle.button_background}
                borderWidth={1}
                h={10}
                mt={1}
                onPress={onConvertPointsToCash}
            >
                <Caption
                    fontSize={14}
                    color={gStyle.button_background}
                    textAlign={'center'}
                    alignItems={'center'}
                    text='giftCard.balance.convert_points_cash'
                />
            </Button>}
        </Box>
    );
};

export default Point;
